import React from 'react'

import { cn } from '@/utilities/ui'

type Props = {
  src: string
  title: string
  className?: string
}

/**
 * A plain 16:9 player. The event embed deliberately omits `/interaction`, so there is no Live
 * Engagement Room sharing the iframe and no reason for the design's 1280x540 stage shape - 16:9
 * is what the board's 1312x738 frame actually is.
 *
 * `allow` and `referrerPolicy` are Vimeo's own values from their generated embed code, and they
 * work for the YouTube replay too.
 *
 * Nothing is overlaid: the design's corner brackets and in-video LIVE pill would sit on top of
 * third-party controls we do not own, so the chrome lives outside the frame instead.
 */
export function StreamEmbed({ src, title, className }: Props) {
  return (
    <div className={cn('absolute inset-0', className)}>
      <iframe
        src={src}
        title={title}
        allow="autoplay; fullscreen; picture-in-picture; encrypted-media; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        className="absolute inset-0 size-full border-0"
      />
    </div>
  )
}
